module.exports = __webpack_public_path__ + "static/team3-1c457a88b358d69757e275fe740c39b1.jpg";